import '../styles/Doctors.css';
import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import DoctorCard from '../components/DoctorCard';

//helper function
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function DoctorsPage() {
  let { specialty } = useParams();
  let query = useQuery();
  const searchTerm = query.get('search');

  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [title, setTitle] = useState('');

  useEffect(() => {
    const fetchDoctors = async () => {
      setLoading(true);
      setError(null);
      
      const baseUrl = process.env.REACT_APP_API_BASE_URL; 
      let apiUrl = '';

      if (searchTerm) {
        // --- SEARCH LOGIC ---
        apiUrl = `${baseUrl}/doctors/search?q=${searchTerm}`;
        setTitle(`Search Results for "${searchTerm}"`);
      } 
      else if (specialty) {
        const cleanSpecialty = specialty.replace(/-/g, ' ');

        apiUrl = `${baseUrl}/doctors/specialty/${cleanSpecialty}`;
        
      } 
      else {
        
        apiUrl = `${baseUrl}/doctors`;
        
      }

      try {
        console.log("Fetching from:", apiUrl);
        const response = await axios.get(apiUrl);
        
       
        setDoctors(response.data.data || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load doctors.');
        console.error(err);
        setDoctors([]); 
      }
      setLoading(false);
    };

    fetchDoctors();
  }, [specialty, searchTerm]);

  // 8. Render loading/error states
  if (loading) {
    return <div className="container" style={{ marginTop: '100px' }}></div>;
  }
  if (error) {
    return <div className="container" style={{ marginTop: '100px' }}><h2>{error}</h2></div>;
  }


  return (
    <div className="container">
      <h1 className="text-center my-4" style={{ textTransform: 'capitalize' }}>
        {title} 
      </h1>

      {doctors.length > 0 ? (
        
        <div className="row justify-content-center"> 
          {doctors.map(doctor => (
            <DoctorCard key={doctor._id} doctor={doctor} />
          ))}
        </div>
      ) : (
        <div className="alert alert-warning text-center">
            <h3>No doctors found.</h3>
            <p>We could not find any doctors matching "{specialty ? specialty.replace(/-/g, ' ') : searchTerm}".</p>
        </div>
      )}
    </div>
  );
}

export default DoctorsPage;